/* istanbul ignore file */
/* tslint:disable */
 
import type { ActionDetails } from '../models/ActionDetails';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ActionsService {

  /**
   * @returns ActionDetails 
   * @throws ApiError
   */
  public static actionsList(): CancelablePromise<Array<ActionDetails>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/actions/',
    });
  }

  /**
   * @param codeName 
   * @returns ActionDetails 
   * @throws ApiError
   */
  public static actionsRetrieve(
codeName: string,
): CancelablePromise<ActionDetails> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/actions/{code_name}',
      path: {
        'code_name': codeName,
      },
    });
  }

}
